import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { EmployeeProps } from 'types/props-obj/EmployeeProps';
import { openSnackbar } from './snackbar';
const initialState: EmployeeProps = {
    apiEndPoint: "employee",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:5,
    current_page:1,
    list: [],
    item: null,
    error: null,
    alertPopup: false,
    isLoading: false
  };
const employee = createSlice({
    name: 'employee',
    initialState,
    reducers: {

        hasError(state, action) {
            state.error = action?.payload;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
            if(action.payload){
                state.error=null;
            }
            console.log(state.error);
            
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Employee list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {

            state.isOpen = action.payload.isOpen;
        },
        // get Employee details
        setEmployee(state, action) {
            state.item = action.payload;
            state.isLoading=false;
        },

        // GET Employees
        setEmployeesSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total;
            state.isLoading=false;
        },

        // ADD Employee
        addEmployeeSuccess(state, action) {
            state.list = [...state.list,action.payload];
            state.isLoading=false;
        },

        // EDIT Employee
        editEmployeeSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.list[foundIndex] = action.payload;  
            state.item=action.payload;
            state.isLoading=false;
          
        },

        deleteEmployeeSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
            state.isLoading=false;
        }
    }
  });
  export default employee.reducer;

export const { alertPopupToggle,openToggle,setPageLimit,setPageNumber } = employee.actions;
export function getEmployees(params:any={}) {
    return async () => {
        dispatch(employee.actions.setLoading(true));

        try {
            const response = await axios.get(initialState.apiEndPoint,{params:params});
            dispatch(employee.actions.setEmployeesSuccess(response.data));
        } catch (error:any) {
            dispatch(employee.actions.hasError(error?.message));
            dispatch(employee.actions.setLoading(false));
        }
    };
}

export function getEmployee(id: number | undefined) {
    return async () => {
        dispatch(employee.actions.setLoading(true));
        try {
            const response = await axios.get([initialState.apiEndPoint,  id].join('/'));
            dispatch(employee.actions.setEmployee(response.data));
        } catch (error:any) {
            dispatch(employee.actions.hasError(error?.message));
            dispatch(employee.actions.setLoading(false));
        }
    };
}

export function addEmployee(ls:any) {
    return async () => {
        dispatch(employee.actions.setLoading(true));
        try {
            const response = await axios.post(initialState.apiEndPoint, ls);
            dispatch(employee.actions.addEmployeeSuccess(response.data));
            openSnackbar({
                open: true,
                message: 'Employee added successfully.',
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false
            })
        } catch (error:any) {
            
            dispatch(employee.actions.hasError(error?.message));
            dispatch(employee.actions.setLoading(false));
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Unable to add Employee.',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
           
        }
    };
}

export function editEmployee(id: number | undefined,ls: any) {
    return async () => {
        dispatch(employee.actions.setLoading(true));
        try {
            const response = await axios.put([initialState.apiEndPoint,  id].join('/'), ls);
            dispatch(employee.actions.editEmployeeSuccess(response.data));
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Employee update successfully.',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        } catch (error:any) {
            dispatch(employee.actions.hasError(error?.message));
            dispatch(employee.actions.setLoading(false));
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Unable to edit Employee.',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}
export function updateProfilePic(id: number | undefined,ls: any) {
    return async () => {
        dispatch(employee.actions.setLoading(true));
        try {
            const response = await axios.post([initialState.apiEndPoint,  id,'profile-picture'].join('/'), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(employee.actions.editEmployeeSuccess(response.data));
        } catch (error:any) {
            
            dispatch(employee.actions.hasError(error?.message));
            dispatch(employee.actions.setLoading(false));
        }
    };
}
export function updateEmployeePassword(id: number | undefined,password: any) {
    return async () => {
        dispatch(employee.actions.setLoading(true));
        try {
             await axios.post([initialState.apiEndPoint,  id,'update-password'].join('/'), {password:password});
            // dispatch(employee.actions.editEmployeeSuccess(response.data));
        } catch (error:any) {
            dispatch(employee.actions.hasError(error?.message));
            dispatch(employee.actions.setLoading(false));
        }
    };
}
export function deleteEmployee(id: number | undefined) {
    return async () => {
        dispatch(employee.actions.setLoading(true));
        try {
            await axios.delete([initialState.apiEndPoint,  id].join('/'));
            dispatch(employee.actions.deleteEmployeeSuccess(id));
        } catch (error:any) {
            dispatch(employee.actions.hasError(error?.message));
            dispatch(employee.actions.setLoading(false));
        }
    };
}